import { memo } from 'react';

import { ShareButton } from '~/components/AssetModalV2/Header/components/ShareButton';
import { usePublicClipAssetShare } from '~/components/AssetModalV2/Header/PublicAssetComponents/usePublicClipAssetShare';
import { ASSET_SHARE_BUTTON_PUBLIC } from '~/constants/testIDs';

export const PublicAssetShareButton = memo(() => {
  const { sharePublicClipAsset } = usePublicClipAssetShare();

  return <ShareButton onClick={sharePublicClipAsset} dataTestId={ASSET_SHARE_BUTTON_PUBLIC} />;
});

PublicAssetShareButton.displayName = 'PublicAssetShareButton';
